// components/habits/habits.component.jsx
import React, { useState, useEffect } from "react";

import { db, updateHabitHistory } from "../../firebase/firebase.utils";

import { useSearchParams } from "react-router-dom";

import Habit from "./habit/habit.component";
import HabitAnimation from "./habit/habit-animation.component";

import { useSelector, useDispatch } from "react-redux";

import { setHabits } from "../../redux/habits/habits.actions";

import InvitetoPremium from "../marketing/invite-to-premium.component";

import "react-datepicker/dist/react-datepicker.css";

import { datetime, RRule, RRuleSet, rrulestr } from "rrule";
import { IoRepeat } from "react-icons/io5";

import "./habits.styles.scss";

import InlineAddBtn from "../InlineAddBtn";
import { FiSquare, FiCheckSquare } from "react-icons/fi";

import { Circle } from "rc-progress";

export default function Habits({ currentUser, display }) {
  const userEntitlement = useSelector((state) => state.user.entitlement);

  const [searchParams, setSearchParams] = useSearchParams();

  const habitParamId = searchParams.get("habit");

  const dispatch = useDispatch();

  const [userHabits, setUserHabits] = useState([]);
  const [habitIcon, setHabitIcon] = useState("");
  const [habitName, setHabitName] = useState("");
  const [relatedSpaceId, setRelatedSpaceId] = useState("");
  const [relatedStationId, setRelatedStationId] = useState("");
  const [refrrule, setRefRRule] = useState(
    "RRULE:FREQ=DAILY;INTERVAL=1;COUNT=5",
  );
  const [step, setStep] = useState(1);
  const [steps, setSteps] = useState(1);
  const [unit, setUnit] = useState("time(s)");

  const [habitmodalMode, setHabitModalMode] = useState("");
  const [showhabitmodal, setShowHabitModal] = useState(false);

  const [showAllHabits, setShowAllHabits] = useState(false);

  const [activeHabit, setActiveHabit] = useState("");

  const [animRefHabit, setanimRefHabit] = useState("");

  const [showInvitation, setShowInvitation] = useState(false);

  let newDate = new Date();
  let date = ("0" + newDate.getDate()).slice(-2);
  let month = ("0" + (newDate.getMonth() + 1)).slice(-2);
  let year = newDate.getFullYear();

  const [selectedDate, setSelectedDate] = useState(`${year}-${month}-${date}`);

  useEffect(() => {
    //mounts
    const unsub = db
      .collection("users")
      .doc(currentUser.uid)
      .collection("habits")
      .onSnapshot((querySnapshot) => {
        if (querySnapshot) {
          const array = querySnapshot.docs.map((doc) => {
            return {
              id: doc.id,
              name: doc.get("name"),
              icon: doc.get("icon"),
              history: doc.get("history"),
              relatedSpaceId: doc.get("relatedSpaceId"),
              relatedStationId: doc.get("relatedStationId"),
              refrrule: doc.get("rrule"),
              step: doc.get("step"),
              steps: doc.get("steps"),
              unit: doc.get("unit"),
            };
          });
          setUserHabits([...array]);
          dispatch(setHabits([...array]));
        }
      });

    return () => {
      unsub();
    };
  }, [currentUser]);

  useEffect(() => {
    if (habitParamId?.length > 0) {
      console.log("HABITPARAMID", habitParamId);
      const foundHabit = userHabits.filter((hbt) => hbt.id === habitParamId);
      if (foundHabit.length > 0) {
        console.log("FOUNDHABIT", foundHabit[0]);
        handleHabitClick(foundHabit[0]);
      }
    }
  }, [habitParamId, userHabits]);

  const handleHabitClick = (habit) => {
    // setSearchParams({ habit: habit.id });
    setHabitModalMode("edit");
    setActiveHabit(habit);
    setHabitIcon(habit.icon);
    setHabitName(habit.name);
    setRelatedSpaceId(habit.relatedSpaceId);
    setRelatedStationId(habit.relatedStationId);
    setRefRRule(habit.refrrule);
    setStep(habit.step);
    setSteps(habit.steps);
    setUnit(habit.unit);
    setShowHabitModal(true);
    // setRefRRule("")
  };

  const handleAddBtnClick = () => {
    setHabitModalMode("add");
    setHabitIcon("❔");
    setHabitName("");
    setShowHabitModal(true);
  };

  const handleHabitMarkDone = async (habit) => {
    //Save Steps (the goal) and the step (value of increment with each check) to the document field
    //Save percentage or fraction of how many steps completed to history {date: yyyy-mm-dd, stepdone: 60%}
    //When checked increment it by step/steps

    //steps/step = nr of steps

    const incrementalvalue = habit.step / habit.steps;

    const firstcheckrecord = {
      date: selectedDate,
      checked: Math.min(1, incrementalvalue),
    };

    const resetcheckrecord = {
      date: selectedDate,
      checked: 0,
    };

    const historyarray = Array.isArray(habit.history) ? [...habit.history] : [];
    //check if today's object exist
    const findIndex = historyarray.findIndex(
      (item) => item.date === selectedDate,
    );
    if (findIndex === -1) {
      historyarray.push(firstcheckrecord);
    } else if (historyarray[findIndex].checked < 1) {
      const newcheckedVal = Math.min(
        1,
        Number(historyarray[findIndex].checked) + Number(incrementalvalue),
      );
      const incrementcheckrecord = {
        date: selectedDate,
        checked: Math.round(newcheckedVal * 100) / 100,
        //read the value and increment it by step / steps
      };
      historyarray.splice(findIndex, 1);
      historyarray.splice(findIndex, 0, incrementcheckrecord);
      if (newcheckedVal >= 1) {
        setanimRefHabit(habit.id);
      } else {
        document.getElementById("habit-check_tone").play();
      }
    } else if (historyarray[findIndex].checked >= 1) {
      historyarray.splice(findIndex, 1);
      historyarray.splice(findIndex, 0, resetcheckrecord);
    }

    await updateHabitHistory(currentUser.uid, habit.id, historyarray);
  };

  const handleCloseHabit = () => {
    if (habitmodalMode === "add") {
      setShowHabitModal(false);
      setHabitName("");
      setHabitIcon("");
    } else {
      setShowHabitModal(false);
      setHabitName("");
      setHabitIcon("");
      setSearchParams(searchParams.append("habit", ""));
    }
  };

  function checkTodaysHistory(habit) {
    const historyarray = habit.history;
    const findIndex = historyarray.findIndex(
      (item) => item.date === selectedDate,
    );
    if (findIndex === -1 || historyarray[findIndex].checked === 0)
      return (
        <i className="habit-checkbox">
          <FiSquare />
        </i>
      );
    else if (1 > historyarray[findIndex].checked > 0)
      return (
        <i className="habit-checkbox-colored">
          <FiSquare />
        </i>
      );
    else
      return (
        <i className="habit-checkbox-done">
          <FiCheckSquare />
        </i>
      );
  }

  function checkCircleStatus(habit) {
    const historyarray = habit.history;
    const findIndex = historyarray.findIndex(
      (item) => item.date === selectedDate,
    );
    const percentVal =
      findIndex === -1 ? 0 : historyarray[findIndex].checked * 100;
    // const percentVal = historyarray[findIndex].checked * 100;
    const circleSteps = habit.steps / habit.step;
    if (circleSteps > 1)
      return (
        <Circle
          percent={percentVal}
          strokeWidth={6}
          steps={{
            count: circleSteps,
            space: 10,
          }}
          strokeColor={"#1A82C4"}
        />
      );
    else
      return (
        <Circle percent={percentVal} strokeWidth={6} strokeColor={"#1A82C4"} />
      );
  }

  const handleCheckEntitlement = () => {
    if (userEntitlement === "free") {
      if (userHabits?.length < 2) {
        handleAddBtnClick();
      } else {
        // show invitation
        setShowInvitation(true);
      }
    } else if (userEntitlement === "antPro") {
      handleAddBtnClick();
    } else if (userEntitlement === "antBusiness") {
      handleAddBtnClick();
    }
  };

  return (
    <div className="habits" id="habits" style={{ display: display }}>
      <div className="widgetbtns">
        <button
          className={
            showAllHabits ? "habit__today-btn" : "habit__today-btn-passive"
          }
          onClick={() => setShowAllHabits(true)}
        >
          All
        </button>
        <button
          className={
            !showAllHabits ? "habit__today-btn" : "habit__today-btn-passive"
          }
          onClick={() => setShowAllHabits(false)}
        >
          Today's
        </button>
      </div>
      <div className="habitcontent">
        {!userHabits.length && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              rowGap: "30px",
              color: "#cccccc",
            }}
          >
            <IoRepeat size="4em" color="#dddddd" /> No habits found.
          </div>
        )}
        {!showAllHabits &&
          userHabits.filter((habit) => {
            return showAllHabits
              ? habit
              : rrulestr(habit.refrrule).between(
                  datetime(`${year}`, `${month}`, `${date}`, 0, 0),
                  datetime(`${year}`, `${month}`, `${date}`, 23, 59),
                ).length > 0;
          }).length === 0 && (
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                rowGap: "30px",
                color: "#cccccc",
              }}
            >
              There is no recurring habit today.
            </p>
          )}
        {userHabits
          .filter((habit) => {
            return showAllHabits
              ? habit
              : rrulestr(habit.refrrule).between(
                  datetime(`${year}`, `${month}`, `${date}`, 0, 0),
                  datetime(`${year}`, `${month}`, `${date}`, 23, 59),
                ).length > 0;
          })
          .map((habit) => {
            const { name, icon, id, steps, refrrule } = habit;
            return (
              // <Link to={`/s/${data.spaceId}`}>
              <div key={id} className="habitline-main">
                {/* {() => checkIfToday(refrrule)} */}
                <div
                  onClick={() => handleHabitClick(habit)}
                  className="habitinfo"
                >
                  <div className="habit-progress-icon">
                    <span>{icon}</span>
                    <div
                      className="habit-progress-circle"
                      style={{ width: 40 }}
                    >
                      {checkCircleStatus(habit, steps, step)}
                    </div>
                  </div>
                  <h5>{name}</h5>
                </div>
                <i onClick={() => handleHabitMarkDone(habit)}>
                  {checkTodaysHistory(habit)}
                </i>
                <audio
                  id="habit-check_tone"
                  src="/media/mixkit-modern-technology-select-3124.wav"
                ></audio>
                <HabitAnimation
                  habit={habit}
                  animRefHabit={animRefHabit}
                  setanimRefHabit={setanimRefHabit}
                />
              </div>
              // </Link>
            );
          })}
          <InlineAddBtn
  className="habitadd-btn"
  circleSize={38}
  iconSize={18}
  gap={10}
  fontSize="var(--inline-add-font-size)"
  onClick={handleCheckEntitlement}
>
  Add habit
</InlineAddBtn>
      </div>
      {showhabitmodal && (
        <Habit
          currentUser={currentUser}
          habit={activeHabit}
          habitIcon={habitIcon}
          setHabitIcon={setHabitIcon}
          habitName={habitName}
          setHabitName={setHabitName}
          relatedSpaceId={relatedSpaceId}
          relatedStationId={relatedStationId}
          setRefRRule={setRefRRule}
          step={step}
          setStep={setStep}
          steps={steps}
          setSteps={setSteps}
          unit={unit}
          setUnit={setUnit}
          handleCloseHabit={handleCloseHabit}
          habitmodalMode={habitmodalMode}
          selectedDate={selectedDate}
        />
      )}
      {showInvitation && (
        <InvitetoPremium
          setShowInvitation={setShowInvitation}
          featureName={`Creating more than 2 habits`}
          featureDesc={
            "fulfill your resolutions by setting goals and tracking your habits"
          }
          featureImg={
            "https://images.pexels.com/photos/29996961/pexels-photo-29996961.jpeg"
          }
          currentUser={currentUser}
        />
      )}
    </div>
  );
}
